var schemes = {
    list: function (page) {
        var params = utils.getParamObj();
        params.page = page || 1;
        params.like = $('#like').val() || '';

        var getParams = location.pathname+"?"+($.param(params));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#schema_list").html(resp);
            });
        }else{
            location.href=getParams;
        }
    },
    edit: function (schemaID) {
        schemaID = schemaID || 0;
        $.post('/admin/schemes/edit/'+schemaID, {}, function(resp){
            popup(resp.html, resp.title)/*.mergeSettings({size: 'large'})*/.dialog();
        }, 'json')
    },
    save: function () {
        var schemaID = $("#schemaID").val(),
            params = $("#schema-popup-form :input").serializeObj();
        $.post('/admin/schemes/save/'+schemaID, params, function(resp){
            $("#schemaID").val(resp);
            notify.add('Save successful!', 'Save successful!', {noteStyle: 'success'});
            schemes.list();
        })
    },
    sort: function (json) {
        $.post('/admin/schemes/sort/'+$("#schemaID").val(), {json:json}, function(resp){

        })
    },
    addSiu: function () {
        var schemaID = $("#schemaID").val(),
            index = $('.sius').length;
        $(".siulist").append('<li class="dd-item dd-primary sius" data-id="siu-'+index+'" data-index="'+index+'"><input type="text" id="siu_'+index+'" class="gui-input p5 siupostfix" style="position:absolute;left: 65px;width: 100px;height: 25px;top: 6px;" onblur="schemes.setSIUPostfix($(this))" /><a class="text-success pull-right fs11 fw600" href="javascript:;" onclick="schemes.addFrame($(this), \''+schemaID+'\')" style="display: block;height: 36px;position: absolute;right: 0;width: 20px;text-align: center;"><span class="fa fa-plus" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);"></span></a> <div class="dd-handle siuname">SIU '+(index+1)+'</div><ol class="dd-list pbn ptn framelist"></ol></li>');
    },
    addFrame: function ($this) {
        var schemaID = $("#schemaID").val(),
            index = $this.parent().find('.frames').length;
        $this.parent().find('.framelist').append('<li class="dd-item dd-info frames" data-id="frame-'+index+'" data-index="'+index+'"><a class="text-success pull-right fs11 fw600" href="javascript:;" onclick="schemes.addScreen($(this), \''+schemaID+'\')" style="display: block;height: 36px;position: absolute;right: 0;width: 20px;text-align: center;"><span class="fa fa-plus" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);"></span></a><div class="dd-handle">Frame '+(index+1)+'</div><ol class="dd-list pbn ptn screenlist"></ol></li>');
        $('#nestable-contextual').nestable('addBtnsAndExpand', $this.parent());
    },
    addScreen: function ($this) {
        var schemaID = $("#schemaID").val(),
            index = $this.parent().find('.screen').length,
            siuindex = $this.parent().parent().parent().attr('data-index'),
            frameindex = $this.parent().attr('data-index');
        $this.parent().find('.screenlist').append('<li class="dd-item dd-info screen" data-id="screen-'+index+'" data-index="'+index+'"><input type="text" id="screen_'+siuindex+'_'+$this.parent().attr('data-index')+'_'+index+'" class="gui-input p5 screenname" style="position:absolute;left: 65px;width: 100px;height: 25px;top: 6px;" onblur="schemes.saveScreen($(this), \''+schemaID+'\')" /><label for="emptyscreen_'+siuindex+'_'+frameindex+'_'+index+'" style="position:absolute;left: 180px;top: 7px;">Empty</label> <input type="checkbox" id="emptyscreen_'+siuindex+'_'+frameindex+'_'+index+'" style="position:absolute;left: 227px;top: 12px;" class="emptyscreen" onclick="schemes.saveScreen($(this), \''+schemaID+'\')" /><div class="dd-handle">Screen </div></li>');
        $('#nestable-contextual').nestable('addBtnsAndExpand', $this.parent());
    },
    setSIUPostfix:function ($this) {
        if($this.val() != ''){
            $this.parent().attr('data-postfix', $this.val());
            $this.parent().find('.siuname').append(' - '+$this.val());
            $this.remove();
        }
    },
    saveScreen: function ($this) {
        var schemaID = $("#schemaID").val(),
            value = '';

        if($this.attr('type') == 'checkbox'){
            value = $this.prop('checked')?'null':0;
        }else{
            value = $this.val();
        }
        $.post('/admin/schemes/saveScreen/'+$this.parent().attr('data-index')+'/'+schemaID, {
            value:value,
            siupostfix:$this.parent().parent().parent().parent().parent().attr('data-postfix'),
            frameindex:$this.parent().parent().parent().attr('data-index'),
            siuindex:$this.parent().parent().parent().parent().parent().attr('data-index')
        }, function(resp){
            if(resp && resp.error){
                utils.error(resp.error);
            }else{
                $this.parent().find('.dd-handle').append(value == 'null'?'EMPTY':value);
                $this.parent().data('name',value);
                $this.parent().find('input,label').remove();
                notify.add('Save successful!', 'Save successful!', {noteStyle: 'success'});
            }

        },'json');
    }
};